import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export const StripeReconcile = () => {
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);
  const run = async (apply) => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin/stripe/reconcile", null, { params: { apply } });
      setRes(data);
      if (apply) toast.success("Reconciled with Stripe");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Reconcile failed");
    } finally {
      setBusy(false);
    }
  };
  const changed = res?.churches.filter((c) => c.error || Object.keys(c.changes || {}).length) || [];
  return (
    <section className="card-soft p-8 mt-8" data-testid="stripe-reconcile">
      <p className="font-display text-navy text-lg font-semibold">Stripe reconciliation</p>
      <p className="text-sm text-muted-ink mt-1">Compares every Stripe-billed church with its current subscription in Stripe. Check first, then apply.</p>
      <div className="flex flex-wrap gap-3 mt-5">
        <button type="button" disabled={busy} onClick={() => run(false)} className="btn-ghost !py-2 text-sm" data-testid="reconcile-check-btn">Check (no changes)</button>
        <button type="button" disabled={busy || !res} onClick={() => run(true)} className="btn-navy !py-2 text-sm inline-flex items-center gap-2" data-testid="reconcile-apply-btn">
          {busy && <Loader2 size={14} className="animate-spin" />}Apply fixes</button>
      </div>
      {res && (
        <div className="mt-5 text-sm space-y-2" data-testid="reconcile-result">
          <p className="text-navy">{res.churches.length} Stripe churches checked · {changed.length} need changes · {res.completed_unrecorded_checkouts.length} unrecorded checkouts · {res.failed_events.length} failed events{res.applied ? " · applied" : ""}</p>
          {changed.map((c) => (
            <pre key={c.church} className="bg-paper rounded-lg p-3 text-xs overflow-x-auto">{c.church}: {c.error || JSON.stringify(c.changes)}</pre>
          ))}
        </div>
      )}
    </section>
  );
};
